<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="row">
          <div class="col-md-12">
            <z-input
              v-model="resource.name"
              label=""
              placeholder="Resource Name"
              @keyup="saveIt = true"
            />
          </div>
          <div class="col-md-12">
            <z-input
              v-model="resource.url"
              label=""
              placeholder="URL address"
              @keyup="saveIt = true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <z-input
              v-model="resource.startDate"
              name="start_date"
              label="Start"
              type="date"
              @change="saveIt = true"
            />
          </div>
          <div class="col-md-6">
            <z-input
              v-model="resource.endDate"
              name="end_date"
              label="End"
              type="date"
              @change="saveIt = true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <z-input
              v-model="resource.required_time"
              label="Required Time (seconds)"
              placeholder="in seconds"
              type="number"
              min="0"
              max="3600"
              @keyup="saveIt = true"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button
              v-show="saveIt"
              class="btn btn-primary me-2"
              @click="performSave(false)"
            >
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
import ZDialog from '@/Components/ZElements/Dialog'
export default {
  name: 'resource-dialog',
  components: {
    ZInput,
    ZSelect,
    ZDialog,
  },
  props: {
    resource: {
      type: Object,
      default: {
        id: null,
        name: '',
        url: '',
        startDate: null,
        endDate: null,
        required_time: 300,
      },
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      invalidMessage: '',
      saveIt: false,
    }
  },
  mounted() {
    this.invalidMessage = ''
  },
  computed: {
    ...mapGetters('challenges', ['challenge']),
    isVisible() {
      return this.resource !== null
    },
    title() {
      let _title = 'Add Resource'
      if (this.resource) {
        if (this.resource.id !== null) {
          _title = 'Edit Resource'
        }
      }
      return _title
    },
  },
  methods: {
    async performSave() {
      this.invalidMessage = ''
      let challengeStartDate = moment(
        moment(this.challenge.visible_date).format('YYYY-MM-DD')
      )
      let challengeEndDate = moment(
        moment(this.challenge.end_date).format('YYYY-MM-DD')
      )
      let startDate = moment(this.resource.startDate)
      let endDate = moment(this.resource.endDate)
      console.log('Save Resource', {
        resource: this.resource,
        challengeStart: challengeStartDate,
        challengEnd: challengeEndDate,
        start: startDate,
        end: endDate,
      })
      if (
        startDate.isBetween(challengeStartDate, challengeEndDate, null, '[]') &&
        endDate.isBetween(challengeStartDate, challengeEndDate, null, '[]')
      ) {
        let valid = true
        let missing = ''
        if (this.resource.name.trim() === '') {
          valid = false
          missing = 'name'
        }
        if (this.resource.url.trim() === '') {
          valid = false
          missing = 'url'
        }
        if (valid) {
          this.$emit('save', this.resource)
          this.$emit('close')
        } else {
          this.invalidMessage = `Please supply the ${missing}. It cannot be empty.`
        }
      } else {
        this.invalidMessage = `Dates must be between the Challenge start (visible)/end (${challengeStartDate.format(
          'MM/DD/YYYY'
        )} - ${challengeEndDate.format('MM/DD/YYYY')}) dates.`
      }
    },
    close() {
      this.invalidMessage = ''
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
</style>
